import SingleArrowNext from '@/components/Icon/SingleArrowNext';

import * as S from './style.ts';

interface PublicationJournalGuideProps {}

const PublicationJournalGuide: React.FC<PublicationJournalGuideProps> = (props) => {
	const onClickJournalSite = () => {
		window.open('http://journal.scsk.or.kr', '_blank');
	};

	return (
		<S.Container>
			<S.ContentBox>
				<S.ContentTitle>대한화장품학회지 바로가기</S.ContentTitle>
				<S.Button className="primary" onClick={onClickJournalSite}>
					대한화장품학회지
					<SingleArrowNext iconColor="#FFFFFF" width="20" height="20" />
				</S.Button>
				<S.ContentDescription>대한화장품학회지의 국문, 영문 검색을 하시려면 위의 버튼을 누르세요.</S.ContentDescription>
			</S.ContentBox>
		</S.Container>
	);
};

export default PublicationJournalGuide;
